'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _fbemitter = require('fbemitter');

var _ = require('../../');

require('./modal-wrapper.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeckoModalWrapper = function (_Component) {
    _inherits(GeckoModalWrapper, _Component);

    function GeckoModalWrapper(props) {
        _classCallCheck(this, GeckoModalWrapper);

        // Create toast event emitter (if not already created)
        var _this = _possibleConstructorReturn(this, (GeckoModalWrapper.__proto__ || Object.getPrototypeOf(GeckoModalWrapper)).call(this, props));

        _this.state = {
            modal: false,
            content: null,
            params: {}
        };
        if (!_.GeckoModalService.emitter) _.GeckoModalService.emitter = new _fbemitter.EventEmitter();

        _.GeckoModalService.emitter.addListener('open', function (content, params) {
            _this.setState({
                modal: true,
                content: content,
                params: params
            }, function () {
                _this.setAriaAttributes();
                _this.setFocus();
            });
        });

        _.GeckoModalService.emitter.addListener('close', function () {
            _this.setState({
                modal: false,
                content: null,
                params: {}
            });
        });

        _this.modalRef = _react2.default.createRef();
        return _this;
    }

    _createClass(GeckoModalWrapper, [{
        key: 'toggle',
        value: function toggle() {
            this.setState({
                modal: !this.state.modal
            });
            // Fire dismiss event (no param to be passed back)
            if (this.state.modal) _.GeckoModalService.emitter.emit('dismiss');
        }
    }, {
        key: 'setAriaAttributes',
        value: function setAriaAttributes() {
            var ref = this.modalRef.current;
            if (ref) {
                try {
                    ref.setAttribute('aria-modal', true);
                    // Optional aria attributes
                    if (this.state.params.ariaLabel) ref.setAttribute('aria-label', this.state.params.ariaLabel);
                    if (this.state.params.ariaDescribedby) ref.setAttribute('aria-describedby', this.state.params.ariaDescribedby);
                    if (this.state.params.ariaLabelledBy) ref.setAttribute('aria-labelledby', this.state.params.ariaLabelledBy);
                } catch (err) {}
            }
        }
    }, {
        key: 'setFocus',
        value: function setFocus() {
            var selector = this.state.params.focusSelector;
            var ref = this.modalRef.current;
            if (ref && selector) {
                try {
                    ref.querySelectorAll(selector)[0].focus();
                } catch (err) {}
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.modal) return null;
            return _react2.default.createElement(
                _reactstrap.Modal,
                Object.assign({}, this.state.params, {
                    innerRef: this.modalRef,
                    isOpen: this.state.modal,
                    toggle: this.toggle.bind(this),
                    wrapClassName: 'gecko-ui-modal-wrapper',
                    fade: false }),
                this.state.content ? this.state.content() : null
            );
        }
    }]);

    return GeckoModalWrapper;
}(_react.Component);

exports.default = GeckoModalWrapper;